/**
 * /frontend/src/features/analytics/components/customers/CustomerBehaviorKPIs.js
 */

import React from 'react';
import KPICardRow from '../shared/KPICardRow';
import KPICard from '../shared/KPICard';
import { formatDays, formatPercent } from '../../utils/formatters';

/**
 * Customer behavior KPI cards.
 * @param {{behavior:any,churnRiskCount:number}} props
 * @returns {JSX.Element}
 */
const CustomerBehaviorKPIs = ({ behavior, churnRiskCount }) => (
  <KPICardRow>
    <KPICard label="Return rate (30d)" value={formatPercent(behavior?.returnRate30d)} />
    <KPICard label="Return rate (60d)" value={formatPercent(behavior?.returnRate60d)} />
    <KPICard label="Return rate (90d)" value={formatPercent(behavior?.returnRate90d)} />
    <KPICard label="Avg gap" value={formatDays(behavior?.avgGapDays)} />
    <KPICard label="Satisfaction" value={formatPercent(behavior?.satisfactionScore)} />
    <KPICard label="At-risk" value={Number(churnRiskCount || 0).toLocaleString('en-IN')} />
  </KPICardRow>
);

export default CustomerBehaviorKPIs;
